import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import AccArrowDown from '../../../../images/contract-admin-icons/AccArrowDown';
import AccArrowUp from '../../../../images/contract-admin-icons/AccArrowUp';
import AccordionSecondChild from './AccordionSecondChild';
import { HISTORICAL_DATA } from '../../constants';

const historicalDataArray = HISTORICAL_DATA;
const AccordionFirstChild = ({
  child = {},
  findObjectAndUpdate,
  data,
  maxHistoricalData,
  hidden,
  twoYrBackData,
  contractEnd,
}) => {
  const [active, setActive] = useState(false);
  const selectedHistoricalData = child.historicalData;
  const handleToggle = () => {
    setActive(!active);
  };
  useEffect(() => {
    if (hidden) {
      setActive(true);
    }
  }, [hidden]);
  return (
    <Fragment>
      {!hidden ? (
        <div className="ent-acc-child">
          <button
            type="button"
            disabled={!child.nodes}
            className={
              child.nodes ? 'ent-acc-toggle' : 'display-hide ent-acc-toggle'
            }
            onClick={handleToggle}
          >
            {active ? <AccArrowUp /> : <AccArrowDown />}
          </button>
          <div className="ent-table-content-old">
            <input
              type="checkbox"
              key={Math.random()}
              disabled={!(child.selected || child.isAnyChildSelected)}
              defaultChecked={child.autoRemove}
              id="autoRemove"
              onChange={e =>
                findObjectAndUpdate(child, e, e.target.checked, data)
              }
            />
          </div>
          <div className="ent-table-content-auto">
            <input
              type="checkbox"
              key={Math.random()}
              disabled={!(child.selected || child.isAnyChildSelected)}
              defaultChecked={child.autoAdd}
              id="autoAdd"
              onChange={e =>
                findObjectAndUpdate(child, e, e.target.checked, data)
              }
            />
          </div>
          <div className="ent-table-content-history">
            <select
              value={selectedHistoricalData}
              key={Math.random()}
              id="historicalData"
              disabled={!(child.selected || child.isAnyChildSelected)}
              onChange={e =>
                findObjectAndUpdate(child, e, e.target.value, data)
              }
            >
              {maxHistoricalData
                ? historicalDataArray.map((item, i) => {
                    return (
                      maxHistoricalData &&
                      i <= data.historicalData && (
                        <option key={item.value}>{item.value}</option>
                      )
                    );
                  })
                : historicalDataArray.map(item => (
                    <option key={item.value}>{item.value}</option>
                  ))}
            </select>
          </div>
          <div
            className={
              child.isAnyChildSelected
                ? 'ent-table-child-release isAnyItemSelected'
                : 'ent-table-child-release'
            }
          >
            <input
              className="ent-table-child-release-input"
              type="checkbox"
              id="selected"
              key={child.optionId + Math.random()}
              defaultChecked={child.selected}
              value={child.selected}
              onChange={e =>
                findObjectAndUpdate(child, e, e.target.checked, data)
              }
            />
            <label htmlFor={child.optionName} title={child.optionName}>
              {child.optionName}
            </label>
          </div>
        </div>
      ) : (
        ''
      )}
      {active &&
        child.nodes &&
        child.nodes.map(item => {
          return (
            <AccordionSecondChild
              child={item}
              findObjectAndUpdate={findObjectAndUpdate}
              data={child}
              hidden={item.hidden}
              twoYrBackData={twoYrBackData}
              contractEnd={contractEnd}
            />
          );
        })}
    </Fragment>
  );
};
AccordionFirstChild.propTypes = {
  child: PropTypes.shape({}),
  findObjectAndUpdate: PropTypes.func,
  maxHistoricalData: PropTypes.string,
  data: PropTypes.shape({}),
  hidden: PropTypes.bool,
  twoYrBackData: PropTypes.bool,
  contractEnd: PropTypes.string,
};

export default React.memo(AccordionFirstChild);
